module.exports = __webpack_public_path__ + "static/img/manual-13.c3ce294.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-13.png
// module id = dbU9
// module chunks = 4